import { SCHEDULELATER_SUCCESS, SCHEDULELATER_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const scheduleLaterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SCHEDULELATER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SCHEDULELATER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default scheduleLaterReducer;
